import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { PopupComponent } from './popup.component';
import { ActionPointMailComponent } from './action-point-mail/action-point-mail.component';
import { AuthGuardService } from '../@core/service/auth-guard.service';


const routes: Routes = [{
  path: '',
  component: PopupComponent,
  canActivate: [AuthGuardService],
  children: [
    {
      path: 'mail',
      component: ActionPointMailComponent,
    }
  ]
  ,
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PopupRoutingModule {
}
